module.exports = __webpack_public_path__ + "img/ck.f708e320.png";